








import Vue from "vue";
import { vueScrollToBottom } from "../../utils/styles";

interface Props {
  isProcessing: boolean;
  texts: string[];
}

/**
 * 30-Jun-2020: drop functional component as watchers are now required
 */
export default Vue.extend<{}, {}, {}, Props>({
  name: "JzMicTextBox",
  props: {
    isProcessing: { type: Boolean, default: false },
    texts: { type: Array as () => string[], required: true }
  },

  watch: {
    texts: {
      async handler(newTexts: string[], oldTexts: string[]) {
        if (newTexts.length !== oldTexts.length) {
          vueScrollToBottom(this);
        }
      }
    }
  }
});
